import React from "react"
import AuthLayout from "../app/layouts/auth-layout/AuthLayout"
import { Navigate, Outlet } from "react-router-dom"

export default function PublicRouter() {
  function getCookie(name) {
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${name}=`)
    if (parts.length === 2) return parts.pop().split(";").shift()
  }

  // Retrieve the token and appID from cookies
  const isLoggedIn = getCookie("access_token_cookie")
  const isAppID = getCookie("app_id")

  if (!isLoggedIn || !isAppID) {
    return (
      <AuthLayout>
        <Outlet />
      </AuthLayout>
    )
  }

  switch (parseInt(isAppID)) {
    case 1:
      window.location.href = process.env.REACT_APP_FRONTEND_URL_SOW_TRACKER
      break
    case 2:
      window.location.href = process.env.REACT_APP_FRONTEND_URL_TPA_TRACKER
      break
    case 3:
      window.location.href = process.env.REACT_APP_FRONTEND_URL_INVOICE_TRACKER
      break
    case 4:
      window.location.href = process.env.REACT_APP_FRONTEND_URL_VISA_TRACKER
      break
    case 5:
      window.location.href = process.env.REACT_APP_FRONTEND_URL_OFFER_LETTER
      break
    default:
      return (
        <AuthLayout>
          <Outlet />
        </AuthLayout>
      )
  }

  return null
}